import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { Link } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faCarSide,
  faEdit,
  faRecycle,
  faRetweet,
  faTrash,
  faUser,
} from "@fortawesome/free-solid-svg-icons";

function ResidenceUser({
  id,
  firstName,
  lastName,
  role,
  resetPassword,
  renewCodes,
  revealCodes,
}) {
  return (
    <Col className="residence-user">
      <Row className="align-items-center">
        <Col lg={6}>
          {firstName} {lastName}
        </Col>
        <Col lg={6} className="right">
          <Dropdown>
            <Dropdown.Toggle
              id="dropdown-basic"
              style={{ backgroundColor: "#03acbe", borderColor: "#03acbe" }}
            >
              <FontAwesomeIcon icon={faBars} />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item as={Link} to={`/edit-user/${id}`}>
                <FontAwesomeIcon
                  icon={faEdit}
                  style={{ color: "#555", marginRight: 5 }}
                />
                Editar
              </Dropdown.Item>
              <Dropdown.Item as={Link} to={`/edit/cardCode/${id}`}>
                <FontAwesomeIcon
                  icon={faCarSide}
                  style={{ color: "#555", marginRight: 5 }}
                />
                Tarjeta vehicular
              </Dropdown.Item>
              <Dropdown.Item as={Link} to={`/edit/keyChain/code/${id}`}>
                <FontAwesomeIcon
                  icon={faUser}
                  style={{ color: "#555", marginRight: 5 }}
                />
                Tarjeta personal
              </Dropdown.Item>
              <Dropdown.Item as={Link} to={`/delete-user/${id}`}>
                <FontAwesomeIcon
                  icon={faTrash}
                  style={{ color: "#555", marginRight: 5 }}
                />
                Eliminar
              </Dropdown.Item>
              {role === "admin" || role === "root" ? (
                <Dropdown.Item onClick={() => resetPassword(id)}>
                  <FontAwesomeIcon
                    icon={faRecycle}
                    style={{ color: "#555", marginRight: 5 }}
                  />
                  Resetear
                </Dropdown.Item>
              ) : (
                <></>
              )}
              {role === "admin" || role === "root" ? (
                <Dropdown.Item onClick={() => renewCodes(id)}>
                  <FontAwesomeIcon
                    icon={faRetweet}
                    style={{ color: "#555", marginRight: 5 }}
                  />
                  Renovar códigos
                </Dropdown.Item>
              ) : (
                <></>
              )}
              {role === "root" ? (
                <Dropdown.Item onClick={() => revealCodes(id)}>
                  <FontAwesomeIcon
                    icon={faUser}
                    style={{ color: "#555", marginRight: 5 }}
                  />
                  Revelar códigos
                </Dropdown.Item>
              ) : (
                <></>
              )}
            </Dropdown.Menu>
          </Dropdown>
          {/* <Button
            size="sm"
            onClick={() => navigate(`/edit-user/${id}`)}
            variant="info"
            style={{ marginRight: 10 }}
          >
            Editar
          </Button>
          <Button
            size="sm"
            onClick={() => navigate(`/edit/cardCode/${id}`)}
            variant="warning"
            style={{ marginRight: 10 }}
          >
            Tarjeta vehicular
          </Button>
          <Button
            size="sm"
            onClick={() => navigate(`/edit/keyChain/code/${id}`)}
            variant="primary"
            style={{ marginRight: 10 }}
          >
            Tarjeta personal
          </Button>
          <Button
            size="sm"
            onClick={() => navigate(`/delete-user/${id}`)}
            variant="danger"
            
          >
            Eliminar
          </Button>
          {(role === "admin" || role === "root")? (
            <Button
              size="sm"
              onClick={() => resetPassword(id)}
              variant="dark"
              style={{ marginLeft: 10 }}
            >
              Resetear contraseña
            </Button>
          ) : (
            <></>
          )} */}
        </Col>
      </Row>
    </Col>
  );
}

export default ResidenceUser;
